export const categoryData = {
  gaoxiao: {
    name: "搞笑综艺",
    description: "爆笑不断的搞笑综艺大全，包袱密集笑到停不下来",
    keywords: "搞笑综艺,搞笑节目,爆笑综艺,喜剧综艺,欢乐综艺",
    shows: [
      {
        id: 1,
        title: "笑傲江湖 第十季",
        image: "https://readdy.ai/api/search-image?query=A%20comedy%20variety%20show%20poster%20with%20bright%20stage%20lights%2C%20comedians%20performing%20on%20stage%2C%20warm%20and%20energetic%20atmosphere%2C%20red%20and%20gold%20color%20scheme%2C%20Chinese%20entertainment%20style&width=600&height=400&seq=cat-gx-1-6789&orientation=landscape",
        description: "国内顶尖喜剧人齐聚一堂，带来最爆笑的舞台表演",
        views: "1.2亿",
        rating: 9.5,
        episode: "更新至第12期",
        date: "2026-07-28",
      },
      {
        id: 7,
        title: "王牌对王牌 第九季",
        image: "https://readdy.ai/api/search-image?query=A%20game%20variety%20show%20with%20two%20teams%20of%20celebrities%20competing%20in%20funny%20games%20on%20a%20colorful%20stage%2C%20bright%20lighting%2C%20comedic%20expressions&width=600&height=400&seq=cat-gx-2-6789&orientation=landscape",
        description: "沈腾贾玲领衔，两队明星爆笑对决，每期都有惊喜嘉宾",
        views: "9800万",
        rating: 9.3,
        episode: "更新至第12期",
        date: "2026-07-26",
      },
      {
        id: 13,
        title: "德云社相声专场 2026",
        image: "https://readdy.ai/api/search-image?query=A%20traditional%20Chinese%20crosstalk%20comedy%20performance%20with%20two%20performers%20in%20traditional%20robes%2C%20warm%20lighting%2C%20Chinese%20cultural%20entertainment&width=600&height=400&seq=cat-gx-3-6789&orientation=landscape",
        description: "德云社年度相声盛典，郭德纲于谦领衔主演",
        views: "6500万",
        rating: 9.6,
        episode: "全集",
        date: "2026-07-20",
      },
      {
        id: 101,
        title: "欢乐喜剧人 第九季",
        image: "https://readdy.ai/api/search-image?query=A%20comedy%20competition%20stage%20with%20multiple%20comedians%20performing%20sketches%2C%20bright%20colorful%20lighting%2C%20Chinese%20variety%20show%2C%20lively%20and%20humorous%20atmosphere&width=600&height=400&seq=cat-gx-4-6789&orientation=landscape",
        description: "全国顶尖喜剧团队竞技，小品相声轮番上演",
        views: "7800万",
        rating: 9.2,
        episode: "更新至第8期",
        date: "2026-07-22",
      },
    ],
  },
  zhenrenxiu: {
    name: "真人秀综艺",
    description: "精彩纷呈的真人秀综艺合集，明星生活真实呈现",
    keywords: "真人秀综艺,真人秀节目,明星真人秀,综艺真人秀,户外真人秀",
    shows: [
      {
        id: 2,
        title: "奔跑吧·勇往直前",
        image: "https://readdy.ai/api/search-image?query=An%20outdoor%20adventure%20reality%20show%20scene%20with%20celebrities%20running%20in%20a%20beautiful%20natural%20landscape%2C%20sunny%20day%2C%20dynamic%20action%20shot&width=600&height=400&seq=cat-zrx-1-6789&orientation=landscape",
        description: "明星嘉宾集结，挑战极限任务，笑料与感动并存",
        views: "9850万",
        rating: 9.3,
        episode: "更新至第8期",
        date: "2026-07-30",
      },
      {
        id: 8,
        title: "向往的生活 第八季",
        image: "https://readdy.ai/api/search-image?query=A%20peaceful%20countryside%20setting%20with%20celebrities%20enjoying%20rural%20life%2C%20cooking%20in%20a%20traditional%20Chinese%20courtyard%2C%20warm%20natural%20lighting&width=600&height=400&seq=cat-zrx-2-6789&orientation=landscape",
        description: "远离城市喧嚣，回归田园生活，每一帧都是治愈",
        views: "7200万",
        rating: 9.1,
        episode: "更新至第8期",
        date: "2026-07-29",
      },
      {
        id: 14,
        title: "乘风破浪的姐姐 第五季",
        image: "https://readdy.ai/api/search-image?query=A%20group%20of%20elegant%20female%20celebrities%20on%20a%20glamorous%20stage%2C%20stunning%20outfits%2C%20powerful%20energy%2C%20Chinese%20reality%20show&width=600&height=400&seq=cat-zrx-3-6789&orientation=landscape",
        description: "30位姐姐重返舞台，唱跳演绎女性力量",
        views: "1.3亿",
        rating: 9.4,
        episode: "更新至第10期",
        date: "2026-08-01",
      },
      {
        id: 102,
        title: "中餐厅 第九季",
        image: "https://readdy.ai/api/search-image?query=Celebrities%20running%20a%20Chinese%20restaurant%20in%20a%20beautiful%20overseas%20location%2C%20cooking%20and%20serving%20customers%2C%20warm%20and%20busy%20atmosphere&width=600&height=400&seq=cat-zrx-4-6789&orientation=landscape",
        description: "明星合伙人在海外经营中餐厅，中华美食走向世界",
        views: "8900万",
        rating: 9.0,
        episode: "更新至第6期",
        date: "2026-07-25",
      },
    ],
  },
  yinyue: {
    name: "音乐综艺",
    description: "震撼人心的音乐综艺荟萃，用歌声打动你的心灵",
    keywords: "音乐综艺,音乐节目,歌唱比赛,音乐真人秀,歌手综艺",
    shows: [
      {
        id: 3,
        title: "中国好声音 2026",
        image: "https://readdy.ai/api/search-image?query=A%20music%20talent%20show%20stage%20with%20dramatic%20lighting%2C%20a%20singer%20performing%20under%20spotlight%2C%20grand%20stage%20design%2C%20Chinese%20singing%20competition&width=600&height=400&seq=cat-yy-1-6789&orientation=landscape",
        description: "四位重量级导师转身抢人，新声代唱将实力对决",
        views: "1.5亿",
        rating: 9.6,
        episode: "更新至第6期",
        date: "2026-08-01",
      },
      {
        id: 9,
        title: "歌手2026",
        image: "https://readdy.ai/api/search-image?query=A%20professional%20singer%20performing%20on%20a%20grand%20stage%20with%20elaborate%20lighting%2C%20dramatic%20atmosphere%2C%20Chinese%20singing%20competition&width=600&height=400&seq=cat-yy-2-6789&orientation=landscape",
        description: "华语乐坛顶级歌手同台竞技，巅峰对决震撼人心",
        views: "1.1亿",
        rating: 9.5,
        episode: "更新至第8期",
        date: "2026-07-31",
      },
      {
        id: 103,
        title: "天赐的声音 第六季",
        image: "https://readdy.ai/api/search-image?query=Two%20singers%20performing%20a%20duet%20on%20a%20beautifully%20lit%20stage%2C%20harmonious%20atmosphere%2C%20Chinese%20music%20show%2C%20emotional%20and%20powerful%20performance&width=600&height=400&seq=cat-yy-3-6789&orientation=landscape",
        description: "音乐合伙人组队PK，经典金曲全新演绎",
        views: "6700万",
        rating: 9.1,
        episode: "更新至第9期",
        date: "2026-07-27",
      },
      {
        id: 104,
        title: "乐队的夏天 第四季",
        image: "https://readdy.ai/api/search-image?query=A%20rock%20band%20performing%20energetically%20on%20a%20dark%20stage%20with%20colorful%20lighting%2C%20electric%20guitars%2C%20Chinese%20band%20competition%2C%20passionate%20live%20music%20atmosphere&width=600&height=400&seq=cat-yy-4-6789&orientation=landscape",
        description: "最热的乐队现场，摇滚、民谣、电子燃爆舞台",
        views: "5400万",
        rating: 9.3,
        episode: "更新至第7期",
        date: "2026-07-24",
      },
    ],
  },
  tuokouxiu: {
    name: "脱口秀",
    description: "妙语连珠的脱口秀精选，每一句都是金句",
    keywords: "脱口秀,脱口秀大会,吐槽大会,搞笑脱口秀,喜剧脱口秀",
    shows: [
      {
        id: 4,
        title: "吐槽大会 第七季",
        image: "https://readdy.ai/api/search-image?query=A%20stand-up%20comedy%20talk%20show%20stage%20with%20a%20comedian%20holding%20a%20microphone%2C%20spotlight%20on%20stage%2C%20audience%20laughing&width=600&height=400&seq=cat-tkx-1-6789&orientation=landscape",
        description: "最辛辣的吐槽，最幽默的表达，明星嘉宾互相爆料",
        views: "8750万",
        rating: 9.1,
        episode: "更新至第10期",
        date: "2026-07-25",
      },
      {
        id: 11,
        title: "脱口秀大会 第六季",
        image: "https://readdy.ai/api/search-image?query=A%20stand-up%20comedian%20delivering%20a%20punchline%20on%20stage%20at%20a%20comedy%20club%2C%20intimate%20spotlight%2C%20Chinese%20comedy%20show&width=600&height=400&seq=cat-tkx-2-6789&orientation=landscape",
        description: "脱口秀新人老将同台PK，笑点密集全程高能",
        views: "9200万",
        rating: 9.2,
        episode: "更新至第10期",
        date: "2026-07-30",
      },
      {
        id: 105,
        title: "今晚80后脱口秀",
        image: "https://readdy.ai/api/search-image?query=A%20comedian%20in%20a%20suit%20talking%20on%20a%20TV%20studio%20set%20with%20a%20city%20skyline%20backdrop%2C%20professional%20talk%20show%20style%2C%20Chinese%20late-night%20comedy&width=600&height=400&seq=cat-tkx-3-6789&orientation=landscape",
        description: "经典脱口秀节目，辛辣点评社会热点，笑中有思",
        views: "4500万",
        rating: 8.9,
        episode: "全集",
        date: "2026-07-18",
      },
      {
        id: 106,
        title: "奇葩说 第九季",
        image: "https://readdy.ai/api/search-image?query=A%20debate%20show%20with%20speakers%20arguing%20passionately%20on%20a%20colorful%20stage%2C%20diverse%20panel%2C%20Chinese%20talk%20show%2C%20intellectual%20and%20humorous%20atmosphere&width=600&height=400&seq=cat-tkx-4-6789&orientation=landscape",
        description: "最强辩手唇枪舌战，奇葩观点刷新三观",
        views: "6900万",
        rating: 9.0,
        episode: "更新至第11期",
        date: "2026-07-28",
      },
    ],
  },
  jingji: {
    name: "竞技综艺",
    description: "热血沸腾的竞技综艺集合，挑战极限见证巅峰",
    keywords: "竞技综艺,竞技节目,体育综艺,挑战综艺,竞赛综艺",
    shows: [
      {
        id: 5,
        title: "极限挑战 第十二季",
        image: "https://readdy.ai/api/search-image?query=A%20competitive%20variety%20show%20with%20celebrities%20doing%20challenging%20missions%20in%20an%20urban%20setting%2C%20action-packed%20scene%2C%20teamwork&width=600&height=400&seq=cat-jj-1-6789&orientation=landscape",
        description: "极限男人帮全新阵容，城市挑战升级",
        views: "1.1亿",
        rating: 9.4,
        episode: "更新至第9期",
        date: "2026-07-27",
      },
      {
        id: 10,
        title: "这！就是街舞 第七季",
        image: "https://readdy.ai/api/search-image?query=A%20street%20dance%20competition%20with%20dancers%20performing%20energetic%20choreography%2C%20futuristic%20stage%2C%20urban%20style%2C%20Chinese%20dance%20show&width=600&height=400&seq=cat-jj-2-6789&orientation=landscape",
        description: "全国顶尖舞者集结，街舞对决燃爆全场",
        views: "7800万",
        rating: 9.3,
        episode: "更新至第6期",
        date: "2026-07-29",
      },
      {
        id: 107,
        title: "最强大脑 第十二季",
        image: "https://readdy.ai/api/search-image?query=A%20brain%20competition%20show%20with%20contestants%20solving%20complex%20puzzles%20on%20a%20high-tech%20stage%2C%20intense%20focus%2C%20Chinese%20intelligence%20show&width=600&height=400&seq=cat-jj-3-6789&orientation=landscape",
        description: "全球脑力精英汇聚，挑战人类智力极限",
        views: "8900万",
        rating: 9.2,
        episode: "更新至第8期",
        date: "2026-07-26",
      },
      {
        id: 108,
        title: "奔跑吧·生态篇",
        image: "https://readdy.ai/api/search-image?query=Celebrities%20competing%20in%20nature-themed%20games%20in%20a%20beautiful%20outdoor%20setting%2C%20green%20forest%20background%2C%20Chinese%20variety%20show%2C%20eco-friendly%20theme&width=600&height=400&seq=cat-jj-4-6789&orientation=landscape",
        description: "跑男团走进大自然，生态主题趣味竞技",
        views: "6200万",
        rating: 8.8,
        episode: "更新至第5期",
        date: "2026-07-23",
      },
    ],
  },
  lvxing: {
    name: "旅行综艺",
    description: "风景如画的旅行综艺大全，跟随镜头走遍世界",
    keywords: "旅行综艺,旅游综艺,旅行节目,户外综艺,旅途综艺",
    shows: [
      {
        id: 6,
        title: "花少看世界 第六季",
        image: "https://readdy.ai/api/search-image?query=A%20travel%20variety%20show%20featuring%20celebrities%20exploring%20an%20exotic%20destination%2C%20beautiful%20scenery%2C%20group%20travel%20vibe&width=600&height=400&seq=cat-lx-1-6789&orientation=landscape",
        description: "明星旅行团踏上全新旅程，异国风情尽收眼底",
        views: "7650万",
        rating: 9.0,
        episode: "更新至第7期",
        date: "2026-07-29",
      },
      {
        id: 12,
        title: "青春环游记 第五季",
        image: "https://readdy.ai/api/search-image?query=Celebrities%20exploring%20an%20ancient%20Chinese%20town%20with%20traditional%20architecture%2C%20cultural%20activities%2C%20group%20travel%20fun&width=600&height=400&seq=cat-lx-2-6789&orientation=landscape",
        description: "青春旅行团探访古城，文化与美食的双重享受",
        views: "5600万",
        rating: 8.9,
        episode: "更新至第5期",
        date: "2026-07-28",
      },
      {
        id: 109,
        title: "妻子的浪漫旅行 第七季",
        image: "https://readdy.ai/api/search-image?query=Couples%20traveling%20in%20a%20romantic%20destination%20with%20beautiful%20scenery%2C%20sunset%20view%2C%20Chinese%20travel%20reality%20show%2C%20warm%20and%20romantic%20atmosphere&width=600&height=400&seq=cat-lx-3-6789&orientation=landscape",
        description: "明星夫妻结伴出游，浪漫旅途中的温情故事",
        views: "4300万",
        rating: 8.7,
        episode: "更新至第9期",
        date: "2026-07-25",
      },
      {
        id: 110,
        title: "奇遇人生 第四季",
        image: "https://readdy.ai/api/search-image?query=A%20celebrity%20exploring%20a%20remote%20beautiful%20location%20with%20stunning%20natural%20landscape%2C%20documentary%20style%2C%20Chinese%20travel%20show%2C%20contemplative%20and%20artistic&width=600&height=400&seq=cat-lx-4-6789&orientation=landscape",
        description: "明星独行探索世界，用旅途寻找人生真谛",
        views: "3800万",
        rating: 9.1,
        episode: "更新至第6期",
        date: "2026-07-22",
      },
    ],
  },
};

export const categorySlugs = ["gaoxiao", "zhenrenxiu", "yinyue", "tuokouxiu", "jingji", "lvxing"];

export const categoryInfo = {
  gaoxiao: { name: "搞笑综艺", description: "爆笑不断的搞笑综艺大全" },
  zhenrenxiu: { name: "真人秀综艺", description: "精彩纷呈的真人秀综艺合集" },
  yinyue: { name: "音乐综艺", description: "震撼人心的音乐综艺荟萃" },
  tuokouxiu: { name: "脱口秀", description: "妙语连珠的脱口秀精选" },
  jingji: { name: "竞技综艺", description: "热血沸腾的竞技综艺集合" },
  lvxing: { name: "旅行综艺", description: "风景如画的旅行综艺大全" },
};